<div class="container py-5" style="max-width: 520px;">
  <div class="text-center mb-4">
    <h2 class="fw-bold mb-1">SwipFx</h2>
    <div class="text-muted">Two-factor verification</div>
  </div>

  <div *ngIf="error" class="alert alert-danger" role="alert">
    {{ error }}
  </div>

  <form class="card shadow-sm" [formGroup]="form" (ngSubmit)="submit()">
    <div class="card-body p-4">

      <div class="mb-2">
        <label class="form-label">
          {{ useRecovery ? 'Recovery code' : 'Authenticator code' }}
        </label>

        <input
          type="text"
          [attr.inputmode]="useRecovery ? 'text' : 'numeric'"
          autocomplete="one-time-code"
          [attr.maxlength]="useRecovery ? 9 : 6"
          class="form-control text-center fw-bold"
          [placeholder]="useRecovery ? 'ABCD-EFGH' : '123456'"
          formControlName="code"
          [class.is-invalid]="submitted && code?.invalid"
        />

        <div class="invalid-feedback" *ngIf="submitted && code?.errors?.['required']">
          Code is required.
        </div>

        <div class="invalid-feedback" *ngIf="submitted && code?.errors?.['pattern']">
          {{ useRecovery ? 'Enter a valid recovery code (ABCD-EFGH).' : 'Enter a valid 6-digit code.' }}
        </div>

        <div class="form-text">
          <ng-container *ngIf="!useRecovery">
            Open your authenticator app and enter the 6-digit code. Codes refresh every 30 seconds.
          </ng-container>
          <ng-container *ngIf="useRecovery">
            Enter one of your saved recovery codes. Each recovery code can be used once.
          </ng-container>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center mb-3">
        <a class="small text-decoration-none" href="javascript:void(0)" (click)="cancel()">
          Back to login
        </a>

        <a class="small text-decoration-none" href="javascript:void(0)" (click)="setMode(!useRecovery)">
          {{ useRecovery ? 'Use authenticator code' : 'Use recovery code' }}
        </a>
      </div>

      <button class="btn btn-primary w-100" type="submit" [disabled]="loading">
        <span *ngIf="!loading">Verify</span>
        <span *ngIf="loading">Verifying...</span>
      </button>
    </div>
  </form>

  <div class="text-center mt-3 text-muted small">
    By continuing, you agree to SwipFx terms.
  </div>
</div>